module.exports = __webpack_public_path__ + "media/brands/facebook-icon-43072eec.svg";